import React from 'react';
import { BsSquare } from '@react-icons/all-files/bs/BsSquare';

import { decorateComponent } from '@/documentComponents';

import { Block } from './Block';
import { BlockInspector } from './BlockInspector';

export default decorateComponent(Block, 'block', {
  id: 'block',
  label: '블럭',
  defaultProps: {
    margin: { top: 0, left: 0, right: 0, bottom: 0 },
    padding: { top: 0, left: 0, right: 0, bottom: 0 },
    border: { width: 0, color: '#000000', radius: 0 },
  },
  renderIcon: () => <BsSquare />,
  renderInspector: BlockInspector,
});
